import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { IoMdClose } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import QuantitySelector from "../components/QuantitySelector";
import {
  increaseQuantity,
  decreaseQuantity,
  removeFromCart,
} from "../redux/store/cartSlice";
// import NewsTicker from "../components/Home/Newtricker";
import Faqs from "../components/Home/Faqs";
import { server } from "../utilis/constant";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartItems } = useSelector((state) => state.cart);

  const handleCheckout = () => {
    navigate("/checkout");
  };

  const subtotalPrice = cartItems.reduce(
    (acc, item) => acc + item.variants?.[0].price * item.quantity,
    0,
  );
  const delivery = 7.95;
  const total = subtotalPrice + delivery;

  return (
    <>
      <div className="bg-black">
        <Navbar />
      </div>

      {/* Breadcrumb */}
      <div className="bg-white w-full py-4 px-4 sm:px-10 lg:px-20 text-sm text-gray-500 border-b">
        <span className="text-gray-800">
          <Link to={"/"}>Home</Link>
        </span>{" "}
        <span className="mx-2">{">"}</span>
        Cart
      </div>

      <div className="bg-gray-50 min-h-screen py-10 px-4 sm:px-6 md:px-10 lg:px-20">
        {/* Title */}
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-800">
            Shopping Cart
          </h1>
          <p className="text-gray-500 mt-2 text-sm sm:text-base">
            Review your items before checkout
          </p>
        </div>

        {cartItems && cartItems.length ? (
          <div className="flex flex-col lg:flex-row gap-10 items-start">
            {/* LEFT SIDE */}
            <div className="w-full lg:w-2/3 space-y-4">
              {/* Desktop Table */}
              <div className="hidden md:block bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
                <table className="w-full border-collapse">
                  <thead className="bg-gray-100 text-gray-600 text-sm uppercase tracking-wide">
                    <tr>
                      <th className="px-6 py-4 text-left">Product</th>
                      <th className="px-6 py-4 text-center">Qty</th>
                      <th className="px-6 py-4 text-left">Price</th>
                      <th className="px-6 py-4 text-left">Total</th>
                      <th className="px-6 py-4"></th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-100">
                    {cartItems.map((item) => (
                      <tr
                        key={item._id}
                        className="hover:bg-gray-50 transition"
                      >
                        {/* Product */}
                        <td className="px-6 py-5">
                          <div className="flex items-center gap-4">
                            <img
                              src={`${server}/${item.image}`}
                              alt={item.title}
                              className="w-16 h-16 rounded-xl object-cover"
                            />

                            <div>
                              <h1 className="font-semibold text-gray-800">
                                {item.title}
                              </h1>
                              <p className="text-sm text-gray-500">
                                {item.vendor}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* Qty */}
                        <td className="text-center">
                          <QuantitySelector
                            value={item.quantity}
                            max={item.variants?.[0].inventory_quantity || 99}
                            min={1}
                            onChange={(newQty) => {
                              if (newQty > item.quantity)
                                dispatch(increaseQuantity(item.id));
                              else if (newQty < item.quantity)
                                dispatch(decreaseQuantity(item.id));
                            }}
                          />
                        </td>

                        {/* Price */}
                        <td className="text-gray-700 font-medium">
                          ${item.variants?.[0].price}
                        </td>

                        {/* Total */}
                        <td className="font-semibold text-gray-900">
                          $
                          {(item.variants?.[0].price * item.quantity).toFixed(
                            2,
                          )}
                        </td>

                        {/* Remove */}
                        <td className="text-center">
                          <button
                            onClick={() => dispatch(removeFromCart(item._id))}
                            className="text-red-500 hover:text-red-700 transition"
                          >
                            <IoMdClose size={20} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="p-5 flex justify-between items-center">
                  <Link
                    to={"/"}
                    className="text-sm text-red-500 underline hover:text-red-700"
                  >
                    Continue Shopping
                  </Link>

                  <div className="text-gray-400 text-sm">
                    Free returns available
                  </div>
                </div>

                <Faqs />
              </div>

              {/* Mobile Cards */}
              <div className="md:hidden space-y-4">
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4"
                  >
                    <div className="flex gap-4">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-20 h-20 rounded-xl object-cover"
                      />

                      <div className="flex-1">
                        <h1 className="font-semibold text-gray-800">
                          {item.title}
                        </h1>
                        <p className="text-sm text-gray-500">{item.vendor}</p>

                        <div className="mt-2 text-gray-700 font-medium">
                          ${item.variants?.[0].price}
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between items-center mt-4">
                      <QuantitySelector
                        value={item.quantity}
                        max={item.variants?.[0].inventory_quantity || 99}
                        min={1}
                        onChange={(newQty) => {
                          if (newQty > item.quantity)
                            dispatch(increaseQuantity(item.id));
                          else if (newQty < item.quantity)
                            dispatch(decreaseQuantity(item.id));
                        }}
                      />

                      <div className="font-semibold">
                        ${(item.variants?.[0].price * item.quantity).toFixed(2)}
                      </div>

                      <button
                        onClick={() => dispatch(removeFromCart(item.id))}
                        className="text-red-500 hover:text-red-700"
                      >
                        <IoMdClose size={20} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="w-full lg:w-1/3">
              <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-6 lg:sticky lg:top-10">
                <h2 className="text-xl font-bold text-gray-800 mb-6">
                  Order Summary
                </h2>

                <div className="space-y-4 text-gray-700">
                  <div className="flex justify-between">
                    <span>Sub-Total</span>
                    <span>${subtotalPrice.toFixed(2)}</span>
                  </div>

                  <div className="flex justify-between">
                    <span>Delivery</span>
                    <span>${delivery.toFixed(2)}</span>
                  </div>

                  <hr />

                  <div className="flex justify-between text-lg font-bold">
                    <span>Total</span>
                    <span>${total.toFixed(2)}</span>
                  </div>
                </div>

                <button
                  onClick={handleCheckout}
                  className="
                w-full mt-6 bg-black text-white py-4 rounded-2xl
                hover:bg-gray-800 active:scale-95 transition
                shadow-md
              "
                >
                  Process Order
                </button>

                <p className="text-xs text-gray-400 text-center mt-4">
                  Secure checkout powered by encrypted payment
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center h-[40vh]">
            <div className="text-center">
              <p className="text-gray-500 text-lg">Your cart is empty 🛒</p>
              <Link
                to="/"
                className="text-sm text-blue-500 underline mt-2 block"
              >
                Start shopping
              </Link>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default Cart;
